module.exports = __webpack_public_path__ + "static/img/product7.b02dbce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product7.png
// module id = 9tgd
// module chunks = 13